import { connect } from 'react-redux';
import ContainerSummary from './ContainerSummary';

import containerPricing from '../../services/designPricing/container';

const mapStateToProps = ({ estimateBuilder }, ownProps) => {
  const { containers, items } = estimateBuilder.entities;

  const container = containers.byId[ownProps.containerId];

  const price = containerPricing(items.byId, 'retail', container);

  return {
    name: container.name,
    price,
  };
};

export default connect(mapStateToProps)(ContainerSummary);
